import { RequestData } from '@ant-design/pro-table';
import { trpc } from '@tencent/tpro_rmonitor_product_manager_product';
import { TrpcRequestConfig } from '@/infrastructure/axios';
import { BusiCode } from '@/infrastructure/axios/code';
import AbstractHttpClient from '@/infrastructure/axios/request';
import {
  IAllowCreateReq,
  IAllowCreateRsp,
  IApply,
  IApplyProductReq,
  IApplyProductRsp,
  IGetApplicationReq,
  IGetApplicationRsp,
  IGetApplyDedailReq,
  IGetApplyDedailRsp,
  IGetApprovalReq,
  IGetApprovalRsp,
  IGetBuglyqqProductsReq,
  IGetBuglyqqProductsRsp,
  IGetProductInfoReq,
  IGetProductInfoRsp,
  IGetProductInfosReq,
  IGetProductInfosRsp,
  IProductDetailInfo,
} from '@/proto/manage';
import { TrpcService } from '@/service/trpc';
import { RecursiveNonNullable, WithTypeCast } from '@raft/utils';
import IDeleteProductReq = trpc.rmonitor.product_manager.IDeleteProductReq;
import IDeleteProductRsp = trpc.rmonitor.product_manager.IDeleteProductRsp;

export type ISetGitRepositoriesReq = WithTypeCast<trpc.rmonitor.product_manager.ISetGitRepositoriesReq>;
export type ISetGitRepositoriesRsp = WithTypeCast<trpc.rmonitor.product_manager.ISetGitRepositoriesRsp>;
export type IGetGitRepositoriesReq = WithTypeCast<trpc.rmonitor.product_manager.IGetGitRepositoriesReq>;
export type IGetGitRepositoriesRsp = WithTypeCast<trpc.rmonitor.product_manager.IGetGitRepositoriesRsp>;

export type IGetAuthorizedProductsReq = WithTypeCast<trpc.rmonitor.product_manager.IGetAuthorizedProductsReq>;
export type IGetAuthorizedProductsRsp = WithTypeCast<trpc.rmonitor.product_manager.IGetAuthorizedProductsRsp>;

export type IToggleIssueRecommendationReq = WithTypeCast<trpc.rmonitor.product_manager.IToggleIssueRecommendationReq>;
export type IToggleIssueRecommendationRsp = WithTypeCast<trpc.rmonitor.product_manager.IToggleIssueRecommendationRsp>;

// eslint-disable-next-line max-len
export type IGetIssueRecommendationSettingReq = WithTypeCast<trpc.rmonitor.product_manager.IGetIssueRecommendationSettingReq>;
// eslint-disable-next-line max-len
export type IGetIssueRecommendationSettingRsp = WithTypeCast<trpc.rmonitor.product_manager.IGetIssueRecommendationSettingRsp>;

export type IGitRepository = WithTypeCast<trpc.rmonitor.product_manager.IGitRepository>;
export type IUpdateProductInfoReq = WithTypeCast<trpc.rmonitor.product_manager.IUpdateProductInfoReq>;
export type IUpdateProductInfoRsp = WithTypeCast<trpc.rmonitor.product_manager.IUpdateProductInfoRsp>;
export type ISetDiagnoseWebhookReq = WithTypeCast<trpc.rmonitor.product_manager.ISetDiagnoseWebhookReq>;
export type ISetDiagnoseWebhookRsp = WithTypeCast<trpc.rmonitor.product_manager.ISetDiagnoseWebhookRsp>;


export type IGetDiagnoseWebhookReq = WithTypeCast<trpc.rmonitor.product_manager.IGetDiagnoseWebhookReq>;
export type IGetDiagnoseWebhookRsp = WithTypeCast<trpc.rmonitor.product_manager.IGetDiagnoseWebhookRsp>;

export class ProductService extends AbstractHttpClient {
  constructor() {
    super({
      serviceName: TrpcService.ProductService,
    });
  }

  /**
   * 申请创建产品
   */
  public async applyProduct(req: IApplyProductReq): Promise<IApplyProductRsp> {
    try {
      return  await this.trpcPost<IApplyProductRsp>('ApplyProduct', req);
    } catch (e) {
      return {};
    }
  }

  /**
   * 获取产品详情
   * @param req
   */
  public async getProductInfo(req: IGetProductInfoReq, config?: any): Promise<IProductDetailInfo> {
    try {
      const res = await this.trpcPost<IGetProductInfoRsp>('GetProductInfo', req, config);
      return res?.productInfo || {};
    } catch (e) {
      return {};
    }
  };


  /**
   * 检查是否可以申请产品
   */
  public async allowCreate(req: IAllowCreateReq): Promise<IAllowCreateRsp> {
    try {
      return await this.trpcPost<IAllowCreateRsp>('AllowCreate', req);
    } catch (e) {
      return {};
    }
  };

  /**
   * 拉取用户发起的【产品创建】申请列表
   * @param req
   */
  public async getApplication(req: IGetApplicationReq): Promise<RequestData<IApply>> {
    try {
      const res = await this.trpcPost<IGetApplicationRsp>('GetApplication', req);
      return {
        data: Array.isArray(res.applications) ? res.applications : [],
        success: true,
        total: res.total ?? 0,
      };
    } catch (e) {
      return {
        data: [],
        success: true,
        total: 0,
      };
    }
  };


  /**
   * 拉取超管才能查看的【产品创建】审批列表
   * @param req
   */
  public async getApproval(req: IGetApprovalReq): Promise<RequestData<IApply>> {
    try {
      const res = await this.trpcPost<IGetApprovalRsp>('GetApproval', req);
      return {
        data: Array.isArray(res.approvals) ? res.approvals : [],
        success: true,
        total: res.total ?? 0,
      };
    } catch (e) {
      return {
        data: [],
        success: true,
        total: 0,
      };
    }
  };


  /**
   * 获取申请详情
   * @param req
   */
  public async getApplyDetail(req: IGetApplyDedailReq): Promise<IApply> {
    try {
      const res = await this.trpcPost<IGetApplyDedailRsp>('GetApplyDedail', req);
      if (res.baseRsp?.code !== BusiCode.Ok) {
        return {};
      }
      return res?.apply || {};
    } catch (e) {
      return {};
    }
  };

  public async deleteProduct(req: IDeleteProductReq, config?: any): Promise<IDeleteProductRsp> {
    try {
      const res = await this.trpcPost('DeleteProduct', req, config);
      return res;
    } catch (e) {
      return {};
    }
  }


  /**
   * 根据bulgyid到qq上查询其负责的产品列表
   * @param req
   */
  public async getBuglyqqProducts(req: IGetBuglyqqProductsReq): Promise<IProductDetailInfo[]> {
    try {
      const res = await this.trpcPost<IGetBuglyqqProductsRsp>('GetBuglyqqProducts', req);
      return Array.isArray(res.productInfos) ? res.productInfos : [];
    } catch (e) {
      return [];
    }
  };

  /**
   * 超管才能的批量获取产品信息
   * @param req
   */
  public async getProductInfos(req: IGetProductInfosReq): Promise<RecursiveNonNullable<IProductDetailInfo>[]> {
    try {
      const res = await this.trpcPost<RecursiveNonNullable<IGetProductInfosRsp>>('GetProductInfos', req);
      return Array.isArray(res.productInfos) ? res.productInfos : [];
    } catch (e) {
      return [];
    }
  };

  /**
   * 设置产品仓库
   */
  public async setGitRepositories(req: ISetGitRepositoriesReq, config?: any): Promise<ISetGitRepositoriesRsp> {
    try {
      return await this.trpcPost<ISetGitRepositoriesRsp>('SetGitRepositories', req, config);
    } catch (e) {
      return {};
    }
  }


  /**
   * 获取产品仓库
   */
  public async getGitRepositories(req: IGetGitRepositoriesReq): Promise<IGitRepository[]> {
    try {
      const res = await this.trpcPost<IGetGitRepositoriesRsp>('GetGitRepositories', req);
      return res.repositories ?? [];
    } catch (e) {
      return [];
    }
  }

  /**
   * 获取产品仓库
   */
  public async getAuthorizedProducts(req: IGetAuthorizedProductsReq): Promise<IGetAuthorizedProductsRsp> {
    try {
      return await this.trpcPost<IGetAuthorizedProductsRsp>('GetAuthorizedProducts', req);
    } catch (e) {
      return {};
    }
  }

  /**
   * 切换用户是否推荐个人相关问题的开关
   */
  public async toggleIssueRecommendation(req: IToggleIssueRecommendationReq): Promise<boolean> {
    try {
      const res = await this.trpcPost<IToggleIssueRecommendationRsp>('ToggleIssueRecommendation', req);
      return res.baseRsp?.code === BusiCode.Ok;
    } catch (e) {
      return false;
    }
  }

  /**
   * 切换用户是否推荐个人相关问题的开关
   */
  public async getIssueRecommendationSetting(req: IGetIssueRecommendationSettingReq):
  Promise<boolean> {
    try {
      const res = await this.trpcPost<IGetIssueRecommendationSettingRsp>('GetIssueRecommendationSetting', req);
      return res.isOpen ?? false;
    } catch (e) {
      return false;
    }
  }

  /**
   * 更新产品（超管）
   */
  public async updateProduct(req: IUpdateProductInfoReq, config?: TrpcRequestConfig): Promise<boolean> {
    try {
      const rsp = await this.trpcPost<IUpdateProductInfoRsp>('UpdateProductInfo', req, config);
      return rsp?.baseRsp?.code === BusiCode.Ok;
    } catch (e) {
      return false;
    }
  }

  /**
   * 设置全局诊断日志webhook
   * @param req
   */
  public async setDiagnoseWebhook(req: ISetDiagnoseWebhookReq):
  Promise<boolean> {
    try {
      const res = await this.trpcPost<ISetDiagnoseWebhookRsp>('SetDiagnoseWebhook', req);
      return res.baseRsp?.code === BusiCode.Ok;
    } catch (e) {
      return false;
    }
  }

  /**
   * 获取全局诊断日志webhook
   * @param req
   */
  public async getDiagnoseWebhook(req: IGetDiagnoseWebhookReq):
  Promise<IGetDiagnoseWebhookRsp> {
    try {
      return await this.trpcPost<IGetDiagnoseWebhookRsp>('GetDiagnoseWebhook', req);
    } catch (e) {
      return {};
    }
  }
}


export const productService = new ProductService();
